import { defaultTqcGaugeCalibDto, TqcGaugeCalibDto } from 'src/dtos/tqcGaugeCalib/tqcGaugeCalibDto';

/** EQM3020 화면용 DTO (tqc_gauge_calib + 조회 조인·표시 필드) */
export interface EQM3020_R01Dto extends TqcGaugeCalibDto {
	compNm: string;
	equipmentNm: string;
	calibPlanDt: string;
	empNm: string;
	resultFileNm: string;
	resultFileData: string;

}

export const defaultEQM3020_R01Dto: EQM3020_R01Dto = {
	...defaultTqcGaugeCalibDto,
	compCd: '1000',
	compNm: '',
	equipmentNm: '',
	calibPlanDt: '',
	empNm: '',
	resultFileNm: '',
	resultFileData: '',
};
